export default __webpack_public_path__ + "automate-bug-triage.jpg";